import { render, staticRenderFns } from "./afterOrderDetail.vue?vue&type=template&id=7b04c39c&scoped=true"
import script from "./afterOrderDetail.vue?vue&type=script&lang=js"
export * from "./afterOrderDetail.vue?vue&type=script&lang=js"
import style0 from "./afterOrderDetail.vue?vue&type=style&index=0&id=7b04c39c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b04c39c",
  null
  
)

export default component.exports